import { gpfHistoryMiddleware as gpfHistoryListMiddleware } from './gpf-history-middleware';

export const gpfHistoryMiddleware = [gpfHistoryListMiddleware];
